export default "__VITE_ASSET__t9_BoZ1J__"